<template>
  <div class="ui container" style="margin-top: 15px">
    <h2 class="ui center aligned icon header modul_header"></h2>
    <div class="ui three item fluid labeled icon pointing menu">
      <a class="item active" data-tab="access">
        <i class="key icon"></i>
        {{ $t("access") }}
      </a>
      <a class="item" data-tab="modules">
        <i class="cubes icon"></i>
        {{ $t("modules") }}
      </a>
      <a class="item" data-tab="messaging" style="display: none">
        <i class="envelope icon"></i>
        {{ $t("messaging") }}
      </a>
      <a class="item" data-tab="system">
        <i class="cogs icon"></i>
        {{ $t("system") }}
      </a>
    </div>
    <div class="ui bottom attached tab active" data-tab="access">
      <enterprises-management />
      <users-management />
      <roles-management />
    </div>
    <div class="ui bottom attached tab" data-tab="modules">
      <modules-management />
    </div>
    <div class="ui bottom attached tab" data-tab="messaging">
      <messaging-management />
    </div>
    <div class="ui bottom attached tab" data-tab="system">
      <system-management />
    </div>
  </div>
</template>

<script>
import EnterprisesManagement from "./EnterprisesManagement";
import UsersManagement from "./users/UsersManagement";
import RolesManagement from "./roles_management/RolesManagement";
import ModulesManagement from "./modules/ModulesManagement";
import MessagingManagement from "./messaging/MessagingManagement";
import SystemManagement from "./system_management/Index";

export default {
  name: "Settings",
  props: [],
  mounted() {
    window.jQuery(".ui.menu .item").tab();
  },
  components: {
    "users-management": UsersManagement,
    "roles-management": RolesManagement,
    "modules-management": ModulesManagement,
    MessagingManagement,
    EnterprisesManagement,
    SystemManagement,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style>
.content.segment {
  padding: 0 !important;
}
.modul_header {
  background-image: url(/images/backgrounds/Modul-15-1.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 75px;
}
</style>
